<template>
    <div>
        <div v-if="exitPaperTest">
            <el-row type="flex" v-if="paperTestButton">
                <el-col :span="18">
                    <el-button type="danger" @click="exitPaperTest = false" plain>进入考试</el-button>
                </el-col>
            </el-row>
            <div class="post-moudle__release" v-if="historyPaperList.length == 0">
                <div class="empty-data">暂无数据</div>
            </div>
            <el-row type="flex" :gutter="20" v-else v-for="(p, index) in historyPaperList" :key="index">
                <el-col :span="6" v-for="item in p" :key="item.paperId">
                    <el-card shadow="hover">
                       <p style="font-size:18px;font-weight:bold;margin-bottom:15px;">
                           {{ item.papername }}
                        </p> 
                       <p style="font-size:14px;color:#909399;margin-bottom:10px;">
                           <span>类别：{{item.category}}</span>
                       </p>
                       <p style="font-size:14px;color:#909399;margin-bottom:10px;">
                           <span>难度：{{item.difficulty}}</span>
                       </p>
                       <p style="font-size:14px;color:#909399;margin-bottom:10px;">
                           <span>分数：{{item.score}}</span>
                       </p>
                       <p style="text-align:right;">
                           <el-link type="primary" @click="paperDetail(item.paperId)">详情</el-link>
                       </p>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div v-else>
            <el-row type="flex" justify="center">
                <el-col :span="18">
                    <el-button type="danger" @click="exitPaperTest = true" plain>历史考试</el-button>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :span="12">
                    <h2 class="paperTitle">{{paper.paperName}}</h2>
                    <p class="paperDesciption">
                       <span>难度: {{paper.difficulty}}</span> 
                       <span style="margin-left:20px;">类别: {{paper.category}}</span>
                    </p>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" v-if="!paperTestButton">
                <el-col :span="18">
                    <span class="paperScoreTitle">分数：</span>
                    <span class="paperScore">{{paper.score == null? 0 : paper.score}}</span>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :span="18">
                    <el-card class="box-card">
                        <el-form :model="optionForm" ref="optionForm" label-position="top">
                            <el-form-item v-for="(item, index) in paper.paperList" :key="index" :label="item.quesName" :prop="aw[index].aw">
                                <el-radio-group v-model="aw[index].aw">
                                    <el-radio :class="item.answer != item.choose? 'radioItemError' : 'radioItemSuccess'" v-for="o in item.optionEntities" :key="o.optionName" :label="o.optionName">{{o.optionContent}}</el-radio>
                                </el-radio-group>
                                <p class="answerClass" v-if="!paperTestButton">正确答案为：{{item.answer}}</p>
                            </el-form-item>

                            <el-form-item v-if="paperTestButton">
                                <el-button type="primary" @click="submitForm('optionForm')">交卷</el-button>
                                <el-button @click="resetForm('optionForm')">重新做</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { 
    getPaperTest, 
    sendPaperCalscore,
    getExitPaperTest,
    getHistoryPaperTest,
    getHistoryPaperList
} from '@/api/api'
export default {
    name:'UserDetailPaper',
    props:{
        serveHost: String
    },
    data() {
        return {
            exitPaperTest: true,
            paperTestButton: true,
            pagNo:1,
            showApplyPost:0,
            paper:{},
            hasMoreArticle:true,
            user:{},
            optionForm:{
                
            },
            aw:[],
            historyPaperList:[]
        }
    },
    methods: {
        submitForm(formName) {
            var _vm = this;
            this.$confirm('确定要交卷吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var papers = this.paper.paperList;
                var count = 0;
                this.aw.forEach((e, i) => {
                   delete papers[i].paperId;
                   delete papers[i].answer;
                   delete papers[i].difficulty;
                   papers[i].choose = e.aw;
                   papers[i].options =  JSON.stringify(papers[i].optionEntities);
                   delete papers[i].optionEntities;
                });
                let user = JSON.parse(localStorage.getItem('user'));
                if(user == null) {
                    this.$alert('请先登录！', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                    return;
                }
                let params = {
                    userId: user.userid,
                    paperId: this.paper.id,
                    questions: JSON.stringify(papers)
                };
                sendPaperCalscore(params, {'Authorization': localStorage.getItem('token')}).then((res) => {
                    let r = res.data;
                    if(r.code != "2000000") {
                        this.$message({
                            type: 'warning',
                            message: '提交失败'
                        });
                        return;
                    } else {
                        // this.$message({
                        //     type: 'success',
                        //     message: '提交成功'
                        // });
                        this.$confirm('所得分数为：' + r.data, '提示', {
                            confirmButtonText: '确定',
                            type: 'success'
                        }).then(() => {
                            this.exitPaperTest = true;
                            this.paperTestButton = false;
                            this.getHistoryPapers();
                        }).catch(() => {
                        });
                    }
                });
            }).catch(() => {
            });
            
        },
        resetForm(formName) {
            this.$confirm('确定要重新做吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.aw.forEach((e, i) => {
                    e.aw = '';
                });
            }).catch(() => {
            });
        },
        paperDetail(paperId) {
            // 获取试卷详情
            getHistoryPaperTest({userId: this.user.userid, paperId: paperId}, {'Authorization': localStorage.getItem('token')}).then((res)=>{
                console.log(res);
                let d = res.data;
                if(!d.data) {
                    this.$message({
                        type: 'error',
                        message: '获取试卷出错'
                    });
                } else {
                    this.aw = [];
                    d.data.paperList.forEach((e, i) => {
                        this.aw.push({aw: e.choose});
                    });
                    this.paper = d.data;
                    this.exitPaperTest = false;
                }
            });
        },
        getHistoryPapers() {
            // 历史考试列表
            getHistoryPaperList({userId: this.user.userid}, {'Authorization': localStorage.getItem('token')}).then((res) => {
                if(res.data.data.length > 0) {
                    var a = [];
                    for(let i = 0;i < res.data.data.length;i++) {
                        if(i % 3 == 0 && i != 0) {
                            if(a.length > 0) {
                                this.historyPaperList.push(a);
                            }
                            a = [];
                        } else if(i % 3 < 3 && i == res.data.data.length - 1) {
                            this.historyPaperList.push(a);
                        }
                        a.push(res.data.data[i]);
                    }
                }
                // console.log(this.historyPaperList);
            });
        }
    },
    mounted() {
        if(localStorage.getItem('user') == null) {
            return;
        }
        this.user = JSON.parse(localStorage.user);
        // 是否已经考过试
        getExitPaperTest({userId: this.user.userid}, {'Authorization': localStorage.getItem('token')}).then((res)=>{
            // console.log(res);
            if(res.data.code == '1016003') {
                this.exitPaperTest = true;
                this.paperTestButton = false;
            } else {
                this.exitPaperTest = false;
                this.paperTestButton = true;
                // 获取考卷
                getPaperTest({}, {'Authorization': localStorage.getItem('token')}).then((res) =>{
                    let d = res.data;
                    // console.log(d);
                    if(d.code != "2000000") {
                        this.$message({
                            type:'warning',
                            message: d.msg
                        });
                        return;
                    } else {
                        d.data.paperList.forEach((e, i) => {
                            this.aw.push({aw: ''});
                        });
                        this.paper = d.data;
                    }
                });
            }
        });

        this.getHistoryPapers();
    }
}
</script>

<style scoped>
.answerClass {
    font-weight: bold;
    color: #909399;
}
.paperScoreTitle {
    font-weight:bold;
    font-size:18px;
    color:#909399;
}
.paperScore {
    font-size:20px;
    color:#F56C6C;
    font-weight:bold;
}
.empty-data {
    margin: 0 auto;
    padding: 50px;
    color: rgba(0,0,0,.32);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}

.paperTitle {
    font-size:2rem;
    text-align:center;
    font-weight: bold;
}

.paperDesciption {
    font-size:1rem;
    text-align:center;
    color:#909399;
    margin-top:20px;
}
</style>